<sbc-exhibitor-entry [exhibitor]="exhibitor" [isExtended]="true" (onCategorySelected)="selectCategory($event)"></sbc-exhibitor-entry>
<div class="related-listing" *ngIf="relatedExhibitors.length">
  <div class="related-header">{{ 'related_listings' | translate }}</div>
  <div class="related-listing-items">
    <sbc-exhibitor-entry *ngFor="let related of relatedExhibitors" [exhibitor]="related" (onCategorySelected)="selectCategory($event)" (onExhibitorSelected)="selectExhibitor($event)"></sbc-exhibitor-entry>
  </div>
</div>
